<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/company/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>Thông điệp từ tổng thống<!--社長的話--></h1>
        </div>
      </header>
      <HeaderNav activeLink="philosophy" />
      <!-- main-section -->
      <section class="main-section">
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8">
                <h2 class="section-title text-center">Anh sẽ cùng em đi hết chặng đường, cùng nhau sẻ chia những điều tốt đẹp<!--一路有你、一起共好--></h2>
              </div>
              <div class="col-md-4">
                <div class="founder-image-box">
                  <img
                    src="@/assets/public/images/founders/社長修3_P01_縮小檔案-1.jpg"
                    alt="社長網頁用照片"
                    class="w-100"
                  />
                  <p class="font-weight-bold mt-3">
                    Nissho Fudizhi (Co., Ltd.) Chi nhánh Đài Loan<!--日商富地滋(股)台灣分公司--><br />Chủ tịch<!--社長-->&nbsp;Miki Koda<!--幸田望希-->
                  </p>
                </div>
              </div>
              <div class="col-md-8" style="position: relative; bottom: 7px">
                <div>
                  <p>
                    Bắt đầu từ năm 2001, Nissho Futizhi chính thức thành lập chi nhánh Đài Loan vào năm 2004 sau ba năm chuẩn bị và lập kế hoạch cho đến nay đã bước sang năm thứ 20.
                    <!--日商富地滋從2001年開始，歷經3年的籌備規劃，於2004年正式成立台灣分公司，迄今邁入第20年。-->
                    <br />
                    “20” là con số mang ý nghĩa sâu sắc. Ở Nhật Bản, đó là một quá trình cần thiết trong cuộc sống của người Nhật và cũng là một trong những cột mốc quan trọng.
                    <!--「20」是一個深具意義的數字。在日本，是日本人人生中必經的過程，同時也是重要的里程碑之一。-->
                    <br />
                    Nó đại diện cho “tuổi trưởng thành” sắp tới và thể hiện trách nhiệm và nghĩa vụ lớn hơn của chúng ta đối với bản thân và tương lai của xã hội.
                    <!--它代表著即將迎接的「成年」，代表著我們對自己、對社會的未來擁有更大的責任與義務。-->
                    <br />
                    Với nỗ lực của mọi người, chúng tôi đang từng bước đưa công nghệ y tế vào cuộc sống của mọi người.
                    <!--在大家的努力下，我們一步步將健康科技帶進每個人的生活，-->
                    <br />
                    Nó cũng đã giúp nhiều người đạt được sự giàu có trong cuộc sống và tận hưởng hạnh phúc thực sự. Tôi xin chân thành cảm ơn sự ủng hộ và tin tưởng của các bạn!
                    <!--也讓許多人們獲得人生的富足，享有真正的幸福，誠摯感謝各位的支持與信任！-->
                  </p>
                  <p>
                    Vào năm 2020, một loại virus Corona mới bất ngờ gây ra mối đe dọa toàn cầu, 
                    <!--2020年，一場突如其來的新型冠狀病毒造成全球性的威脅，-->
                    <br />
                    Nó đã thay đổi thói quen sống của chúng ta và cũng làm thay đổi quá trình toàn cầu hóa.
                    <!--改變了我們的生活習慣，也改變了全球化的進程。-->
                    <br />
                    Dịch bệnh đã tác động lớn đến động lực kinh tế thế giới và thúc đẩy sự hiểu biết của mọi người về axit nucleic cũng như tầm quan trọng của chúng đối với sức khỏe.
                    <!--疫情大大地衝擊世界經濟動能，並且加速了人們對核酸的了解及對健康的重要性。-->
                    <br />
                    Đối mặt với tình hình thế giới mới đầy bất ổn và đầy thách thức như vậy,
                    <!--面對如此不確定、充滿挑戰的世界新局，-->
                    <br />
                    Chúng ta cần vững bước, bám sát tình hình và tích cực đẩy mạnh chiến lược kinh doanh phù hợp với tình hình hiện nay, “chủ động thay đổi, chủ động!”
                    <!--我們需要穩住腳步，依循局勢積極推動符合時局的經營策略，「主動改變、主動出擊！」-->
                  </p>
                  <p>
                    <!-- 走過艱辛的2020年，期許大家與我們迎接成年的同時，<br /> -->
                    Trong thời kỳ hậu dịch bệnh, chúng tôi sẽ tiếp tục đầu tư vào trách nhiệm của doanh nghiệp vì sự phát triển tích cực của xã hội và môi trường,
                    <!--在後疫情時代，我們仍持續投入對社會、環境正向發展的企業責任，-->
                    <br />
                    Chúng tôi cũng tích cực làm việc với nhóm R&D quốc gia để thúc đẩy sự phát triển của ngành công nghệ sinh học của Đài Loan, chú trọng đến công tác phòng chống dịch bệnh và chất lượng cuộc sống cũng như bảo vệ sức khỏe của người dân.
                    <!--並且積極攜手國家研發團隊，促進台灣生技產業的發展，兼顧防疫與生活品質，維護國人的健康。-->
                    <br />
                    Chúng tôi hy vọng rằng mọi người sẽ theo bước chân của chúng tôi và tiến về phía trước,
                    <!--期許大家跟著我們的腳步前進，-->
                    <br />
                    Hãy không ngừng đặt ra cho mình những kế hoạch, ước mơ mới để phản ánh giá trị cuộc sống.
                    <!--不斷地給予自己新的計畫、新的夢想，體現生命的價值。-->
                    <br />
                    Cuối cùng chúng ta hãy đoàn kết những trái tim ấm áp của nhau lại với nhau,
                    <!--最後，讓我們共同凝聚彼此溫暖的心，-->
                    <br />
                    Trong thời đại dường như đầy khủng hoảng và đối mặt với những thách thức gay gắt này, chúng ta hãy cùng nhau hướng tới tương lai tốt đẹp nhất!
                    <!--在這個看似充滿危機、面臨嚴峻挑戰的時代，一起邁向最美好的未來！-->
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/CompanyHeaderNav";
export default {
  name: "CompanyPhilosophyScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
<style lang="scss" scoped>
.founder-image-box {
  width: 220px;
}
@media (min-width: 768px) {
  .founder-image-box {
    width: 90%;
  }
}
</style>
